export const CARD_BACK_NAME_ID_ATTRIBUTE = 'card-back-name';
